function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import lz4 from '../lib/lz4';

var WebTracker = _createClass(function WebTracker(opt) {
  var _this = this,
      _opt$protocol,
      _opt$source,
      _opt$headers;

  _classCallCheck(this, WebTracker);

  _defineProperty(this, "host", void 0);

  _defineProperty(this, "protocol", void 0);

  _defineProperty(this, "time", void 0);

  _defineProperty(this, "count", void 0);

  _defineProperty(this, "headers", void 0);

  _defineProperty(this, "timer", void 0);

  _defineProperty(this, "logs", void 0);

  _defineProperty(this, "projectId", void 0);

  _defineProperty(this, "topicId", void 0);

  _defineProperty(this, "source", void 0);

  _defineProperty(this, "compressType", void 0);

  _defineProperty(this, "correctTimeAndCount", function (num) {
    if (typeof num !== 'number') return 10;

    if (num < 1 || num > 20) {
      return 10;
    }

    return num;
  });

  _defineProperty(this, "objToQuery", function (obj) {
    if (!obj || _typeof(obj) !== 'object') return '';
    return Object.keys(obj).reduce(function (pre, cur) {
      var v = obj[cur];

      if (v === undefined || v === null) {
        return pre;
      }

      if (pre) {
        return "".concat(pre, "&").concat(cur, "=").concat(encodeURIComponent(v));
      }

      return "".concat(cur, "=").concat(encodeURIComponent(v));
    }, '');
  });

  _defineProperty(this, "handleQuery", function (url, params) {
    if (!params) return url;

    var query = _this.objToQuery(params);

    if (url.indexOf('?') !== -1) {
      var lastStr = url.substring(url.length - 1);

      if (lastStr === '&') {
        return "".concat(url).concat(query);
      }

      return "".concat(url, "&").concat(query);
    }

    return query ? "".concat(url, "?").concat(query) : url;
  });

  _defineProperty(this, "jsonStringify", function (obj) {
    try {
      return JSON.stringify(obj);
    } catch (err) {
      return "".concat(obj);
    }
  });

  _defineProperty(this, "handleRequestOptions", function (options) {
    var url = options.url,
        method = options.method,
        params = options.params;

    var body = _this.jsonStringify(options.body);

    var originBodyLength = lz4.Buffer.from(body).length;
    var lz4CompressError = false;

    try {
      body = _this.lz4Compress(body);
    } catch (e) {
      lz4CompressError = true;
    }

    var headers = _objectSpread({}, _this.headers);

    if (lz4CompressError) {
      headers['content-type'] = 'application/json';
    }

    if (!lz4CompressError) {
      headers['x-tls-bodyrawsize'] = "".concat(originBodyLength);
      headers['x-tls-compresstype'] = _this.compressType;
    }

    var resource = _this.handleQuery(url, params);

    return {
      url: resource,
      body: body,
      headers: headers,
      method: method
    };
  });

  _defineProperty(this, "requestByFetch", function (options) {
    var result = _this.handleRequestOptions(options);

    return fetch(result.url, {
      method: result.method,
      headers: result.headers,
      mode: 'cors',
      cache: 'no-store',
      body: result.body,
      keepalive: true
    }).then(function () {
      var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(response) {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                res = '';
                _context.prev = 1;
                _context.next = 4;
                return response.json();

              case 4:
                res = _context.sent;
                _context.next = 12;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                _context.next = 11;
                return response.text();

              case 11:
                res = _context.sent;

              case 12:
                if (!(response.status !== 200)) {
                  _context.next = 14;
                  break;
                }

                throw new Error("Status: ".concat(response.status, ", Error: ").concat(JSON.stringify(res)));

              case 14:
                return _context.abrupt("return", res);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 7]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });

  _defineProperty(this, "requestByXHR", function (options) {
    var result = _this.handleRequestOptions(options);

    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(result.method, result.url, true);

      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            resolve('');
            return;
          }

          var errObj = xhr.response;

          try {
            errObj = JSON.parse(errObj);
          } catch (e) {} finally {
            reject(errObj);
          }
        }
      };

      for (var k in result.headers) {
        xhr.setRequestHeader(k, result.headers[k]);
      }

      xhr.send(result.body);
    });
  });

  _defineProperty(this, "request", function (options) {
    var browserSupportsKeepalive = 'Request' in window && 'keepalive' in new Request('');

    if (browserSupportsKeepalive) {
      return _this.requestByFetch(options);
    }

    return _this.requestByXHR(options);
  });

  _defineProperty(this, "lz4Compress", function (input) {
    var innerInput = lz4.Buffer.from(input);
    var output = lz4.Buffer.alloc(lz4.LZ4.encodeBound(innerInput.length));
    var compressedSize = lz4.LZ4.encodeBlock(innerInput, output);
    output = output.slice(0, compressedSize);
    if (!compressedSize) throw new Error('no need to compress');
    return output;
  });

  _defineProperty(this, "transformObjValueToString", function (obj) {
    var newObj = {};

    for (var i in obj) {
      var v = obj[i];

      if (typeof v !== 'string') {
        newObj[i] = _this.jsonStringify(v);
      } else {
        newObj[i] = v;
      }
    }

    return newObj;
  });

  _defineProperty(this, "sendBatchLogsImmediateInner", function () {
    clearTimeout(_this.timer);
    _this.timer = -1;
    var Logs = _this.logs;
    _this.logs = [];
    return _this.request({
      url: "".concat(_this.protocol, "://").concat(_this.host, "/WebTracks"),
      params: {
        ProjectId: _this.projectId,
        TopicId: _this.topicId
      },
      body: {
        Logs: Logs,
        Source: _this.source
      },
      method: 'post'
    });
  });

  _defineProperty(this, "sendBatchLogsInner", function (options) {
    var _ref2 = options || {},
        onSuccess = _ref2.onSuccess,
        onFail = _ref2.onFail;

    if (_this.logs.length >= _this.count) {
      var Logs = _this.logs;

      _this.sendBatchLogsImmediateInner().then(function () {
        if (onSuccess) {
          onSuccess(Logs);
        }
      }).catch(function (err) {
        if (onFail) {
          onFail(Logs, err);
        }
      });
    } else if (_this.timer < 0) {
      _this.timer = window.setTimeout(function () {
        var Logs = _this.logs;

        _this.sendBatchLogsImmediateInner().then(function () {
          if (onSuccess) {
            onSuccess(Logs);
          }
        }).catch(function (err) {
          if (onFail) {
            onFail(Logs, err);
          }
        });
      }, _this.time * 1000);
    }
  });

  _defineProperty(this, "pushLogs", function (data) {
    var _this$logs;

    var newData = (data || []).map(function (d) {
      return _this.transformObjValueToString(d);
    });

    (_this$logs = _this.logs).push.apply(_this$logs, _toConsumableArray(newData));
  });

  _defineProperty(this, "send", function (data, options) {
    _this.sendBatchLogs([data], options);
  });

  _defineProperty(this, "sendImmediate", function (data) {
    return _this.sendBatchLogsImmediate([data]);
  });

  _defineProperty(this, "sendBatchLogs", function (data, options) {
    _this.pushLogs(data);

    return _this.sendBatchLogsInner(options || {});
  });

  _defineProperty(this, "sendBatchLogsImmediate", function (data) {
    _this.pushLogs(data);

    return _this.sendBatchLogsImmediateInner();
  });

  this.host = opt.host;
  this.protocol = (_opt$protocol = opt.protocol) !== null && _opt$protocol !== void 0 ? _opt$protocol : 'https';
  this.time = this.correctTimeAndCount(opt.time);
  this.count = this.correctTimeAndCount(opt.count);
  this.timer = -1;
  this.projectId = opt.projectId;
  this.topicId = opt.topicId;
  this.source = (_opt$source = opt.source) !== null && _opt$source !== void 0 ? _opt$source : '@volcengine/tls-js-sdk/webtracking';
  this.logs = [];
  this.headers = (_opt$headers = opt.headers) !== null && _opt$headers !== void 0 ? _opt$headers : {};
  this.compressType = 'lz4';
});

export default WebTracker;